import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { UserResponseDto as UserDto } from '@sphere/user/domain'
import { TeachingDto } from '../../teachings/response/teaching.dto'
import { ClassRoleResponseDto } from './class-role.dto'
import type { ClassMembershipCapabilities } from '../../../interfaces/class'

/**
 * DTO de réponse pour un membre de classe enrichi
 */
export class ClassMembershipResponseDto {
  @ApiProperty({ type: 'string', description: 'ID du membership' })
  id!: string

  @ApiProperty({ type: 'string', description: 'ID de la classe' })
  classId!: string

  @ApiProperty({ type: 'string', description: "ID de l'utilisateur" })
  userId!: string

  @ApiProperty({ description: "Nom de l'utilisateur", type: () => UserDto })
  user!: UserDto

  @ApiProperty({ type: 'string', description: 'ID du rôle' })
  roleId!: string

  @ApiProperty({ description: 'Rôle', type: () => ClassRoleResponseDto })
  role!: ClassRoleResponseDto

  @ApiProperty({
    description: 'Capabilities calculées pour ce membership',
    type: 'object',
    additionalProperties: false,
    properties: {
      canView: { type: 'boolean' },
      canEdit: { type: 'boolean' },
      canDelete: { type: 'boolean' },
    },
  })
  capabilities!: ClassMembershipCapabilities

  @ApiProperty({ type: Boolean, description: 'Délégué de classe' })
  isHead!: boolean

  @ApiProperty({ type: 'string', format: 'date-time', description: "Date d'adhésion" })
  joinedAt!: Date

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true, description: 'Date de départ' })
  leftAt!: Date | null

  @ApiProperty({ type: Boolean, description: 'Actif' })
  isActive!: boolean

  @ApiProperty({ type: 'string', format: 'date-time', description: 'Date de création' })
  createdAt!: Date

  @ApiProperty({ type: 'string', format: 'date-time', description: 'Date de mise à jour' })
  updatedAt!: Date

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true, description: 'Date de suppression' })
  deletedAt!: Date | null

  @ApiPropertyOptional({
    description: 'Informations sur la classe',
    type: 'object',
    additionalProperties: false,
    properties: {
      id: { type: 'string' },
      name: { type: 'string' },
      establishmentId: { type: 'string' },
      level: {
        type: 'object',
        additionalProperties: false,
        properties: {
          code: { type: 'string' },
          label: { type: 'string' },
        },
      },
    },
  })
  class?: {
    id: string
    name: string
    establishmentId: string
    level?: {
      code: string
      label: string
    }
  }

  @ApiPropertyOptional({
    description: 'Les teachings associés à la leçon',
    type: () => [TeachingDto],
  })
  teachings?: TeachingDto[]
}
